import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:4000';
const socket = io(SOCKET_URL, {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

let isConnected = false;

export const initializeSocket = (dispatch, userId) => {
  if (userId && !isConnected) {
    socket.connect();
    socket.emit('join', { user_id: userId });

    socket.on('connect', () => {
      isConnected = true;
    });

    socket.on('connect_error', (error) => {
      console.error('Socket.IO connection error:', error.message);
      isConnected = false;
    });

    socket.on('disconnect', () => {
      isConnected = false;
    });

    // ✅ السعر الحيّ من الباك إند (تأكّد أن السيرفر يرسل {symbol, price})
    socket.on('current_price', (data) => {
      if (!data || data.price == null || isNaN(data.price) || !data.symbol) return;

      const symbol = String(data.symbol).toUpperCase();
      const price = Number(data.price);

      // (1) حدّث aiTrading لو عندك شاشة AI
      dispatch({ type: 'aiTrading/updateCurrentPrice', payload: { symbol, price } });

      // (2) ✅ الأهم: حدّث أسعار الـ assets علشان نقدر نحسب الـ PnL لايف
      dispatch({ type: 'assets/updateCoinPrice', payload: { symbol, price } });
    });

    // باقي الأحداث الخاصة في مشروعك (مثال):
    socket.on('futures_order_status_update', (payload) => {
      dispatch({ type: 'futures/updateOrderStatus', payload });
    });
  }

  return socket;
};

export const disconnectSocket = () => {
  if (isConnected) {
    socket.off('connect');
    socket.off('connect_error');
    socket.off('disconnect');
    socket.off('current_price');
    socket.off('futures_order_status_update');
    socket.disconnect();
    isConnected = false;
  }
};

export default socket;
